interface Date {
  /**
   * Returns the date part of a date string. YYYY-MM-DD by splitting toISOString on 'T'
   */
  datePart(): string;

  /**
   * Returns true if the date is in the past.
   */
  isHistorical(): boolean;

  /**
   * Returns true if the date is in the future.
   */
  isFuture(): boolean;

  /**
   * Adds the given number of years to the date.
   */
  addDays(days: number): Date | null;

  /**
   * Adds the given number of years to the date.
   */
  addYears(years: number): Date | null;

  /**
   * Returns Dec. 31 of that year.
   */
  toLastDayOfYear(): string | null;
}

/**
 * Returns the date part of a date string. YYYY-MM-DD by concatenating year+month+day
 */
Date.prototype.datePart = function (this: Date) {
  return [this.getFullYear(), ('0' + (this.getMonth() + 1)).slice(-2), ('0' + this.getDate()).slice(-2)].join('-');
};

/**
 * Returns true if the date is today or earlier.
 */
Date.prototype.isHistorical = function (this: Date) {
  return this.datePart() <= new Date().datePart();
};

/**
 * Returns true if the date is today or earlier.
 */
Date.prototype.isFuture = function (this: Date) {
  return this.datePart() > new Date().datePart();
};

/**
 * Adds the given number of days to the date.
 */
Date.prototype.addDays = function (this: string, days: number): Date | null {
  if (!this) {
    return null;
  }

  const date = new Date(this);
  date.setDate(date.getDate() + days);
  return date;
};

/**
 * Adds the given number of years to the date.
 */
Date.prototype.addYears = function (this: string, years: number): Date | null {
  if (!this) {
    return null;
  }

  const date = new Date(this);
  date.setFullYear(date.getFullYear() + years);
  return date;
};

/**
 * Returns Dec. 31 of that year.
 */
Date.prototype.toLastDayOfYear = function (this: any): string | null {
  if (!this) {
    return null;
  }

  const date = new Date(this);
  const dateYear = date.getFullYear();
  return `${dateYear}-12-31`;
};

/**
 * Interface for Date Extensions for iso strings representing dates
 */
interface String {
  /**
   * Returns a Date object from an iso string.
   */
  toDate(): Date | null;

  datePart(): string | null;
}

/**
 * Returns a Date object from an iso string.
 */
String.prototype.toDate = function (this: string): Date | null {
  if (!this) {
    return null;
  }

  if (this.length === 10) {
    return new Date(`${this}T00:00:00`);
  }

  return new Date(this);
};

/**
 * Returns the date part of a date string. YYYY-MM-DD by splitting on 'T'
 */
String.prototype.datePart = function (this: string) {
  return this.split('T')[0];
};
